<div>
  @if (label(); as label) {
    <label [for]="innerId()">{{ label }}</label>
  }
  <p-select [options]="options()" [(ngModel)]="model" [optionLabel]="labelKey()" [id]="innerId()">
    <ng-template pTemplate="dropdownicon">
      <svg class="p-icon" width="18" height="18" viewBox="0 0 18 18" fill="currentColor">
        <use [attr.xlink:href]="SvgSpriteIcon.ArrowDownSLine"></use>
      </svg>
    </ng-template>
  </p-select>
</div>
